// contact-display.js — source unique de vérité pour l'affichage des contacts.
//
// Le backend garantit déjà :
//   - clientName  : jamais un JID brut (toujours un libellé affichable)
//   - clientPhone : E.164 ("+237694954113") ou chaîne vide
//   - hasRealNumber : true uniquement si clientPhone est un vrai numéro résolu
//
// Règle : on groupe/stocke TOUJOURS par conversation _id (ou clientId, le
// "from" JID stable) — JAMAIS par numéro de téléphone.

/**
 * Nom affichable d'un contact. Ne retombe JAMAIS sur le numéro :
 * le backend fournit toujours un clientName lisible.
 * @param {{ clientName?: string }} c
 * @returns {string}
 */
export function contactDisplayName(c) {
  const name = c?.clientName && c.clientName.trim();
  return name || 'Contact';
}

/**
 * Ligne de numéro à afficher, ou null si aucun vrai numéro n'est disponible.
 * Embellit le E.164 ("+237694954113" -> "+237 694 954 113") — purement cosmétique.
 *
 * hasRealNumber peut être :
 *   - top-level (c.hasRealNumber) — quand le backend le flattened
 *   - dans c.metadata.hasRealNumber — structure MongoDB natale (lean())
 *   - implicite si clientPhone commence par "+" (E.164 valide)
 *
 * @param {{ clientPhone?: string, hasRealNumber?: boolean, metadata?: { hasRealNumber?: boolean } }} c
 * @returns {string|null}
 */
export function contactNumberLine(c) {
  const phone = c?.clientPhone;
  if (!phone) return null;

  const hasReal =
    c?.hasRealNumber ||
    c?.metadata?.hasRealNumber ||
    phone.startsWith('+');

  if (hasReal) {
    return phone.replace(/^(\+\d{1,3})(\d{3})(\d{3})(\d+)$/, '$1 $2 $3 $4');
  }
  return null;
}

export default contactNumberLine;
